export const ID = 'be-the-hero:id'
export const NAME = 'be-the-hero:name'
